import { getConvertUnitFromTo } from 'helpers/unitConversionHelpers';

const convertStdPackage = (value, fromUnit, toUnit, productObj, convertFn) => {
  try {
    return getConvertUnitFromTo(value, fromUnit, toUnit, productObj, convertFn);
  } catch {
    return null;
  }
};

export default convertStdPackage;
